var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestOverviewWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.85714 2.74498C0.85714 1.32482 2.0084 0.173553 3.42857 0.173553H8.57143C9.99159 0.173553 11.1429 1.32482 11.1429 2.74498V7.88784C11.1429 9.30801 9.99159 10.4593 8.57143 10.4593H3.42857C2.0084 10.4593 0.85714 9.30801 0.85714 7.88784V2.74498ZM12.8571 14.745C12.8571 13.3248 14.0084 12.1736 15.4286 12.1736H20.5714C21.9915 12.1736 23.1429 13.3248 23.1429 14.745V19.8878C23.1429 21.308 21.9915 22.4593 20.5714 22.4593H15.4286C14.0084 22.4593 12.8571 21.308 12.8571 19.8878V14.745ZM12.8571 5.31641C12.8571 2.4761 15.1597 0.173553 18 0.173553C20.8404 0.173553 23.1429 2.4761 23.1429 5.31641C23.1429 8.15672 20.8404 10.4593 18 10.4593C15.1597 10.4593 12.8571 8.15672 12.8571 5.31641ZM6 12.1736C3.15968 12.1736 0.85714 14.4761 0.85714 17.3164C0.85714 20.1568 3.15968 22.4593 6 22.4593C8.84031 22.4593 11.1429 20.1568 11.1429 17.3164C11.1429 14.4761 8.84031 12.1736 6 12.1736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestOverviewWhite);
export default __webpack_public_path__ + "static/media/invest_overview_white.c99475a8188222cf7663e5b129710e0c.svg";
export { ForwardRef as ReactComponent };